import React, { Component } from 'react';

export default class Loader extends Component {
  render() {
    const { text, style } = this.props;
    if (text) {
      return (
        <div style={style} data-testid="element-8479a8">
          <div className="lds-ripple" data-testid="element-71f4e1">
            <div data-testid="element-aa47ee"></div>
            <div data-testid="element-984dc7"></div>
          </div>
          <h3 className="center" data-testid="element-c76f25">{text}</h3>
        </div>);

    }
    return (
      <div style={style} className="lds-ripple" data-testid="element-d0a26d">
        <div data-testid="element-708b9c"></div>
        <div data-testid="element-5132f7"></div>
      </div>);

  }
}